export default __webpack_public_path__ + "static/media/logged.730f7d4f.webp";